/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LegalAgreementLanguage = {
    De: 'DE',
    En: 'EN',
    Es: 'ES',
    Fr: 'FR',
    Nl: 'NL'
} as const;
export type LegalAgreementLanguage = typeof LegalAgreementLanguage[keyof typeof LegalAgreementLanguage];


export function instanceOfLegalAgreementLanguage(value: any): boolean {
    for (const key in LegalAgreementLanguage) {
        if (Object.prototype.hasOwnProperty.call(LegalAgreementLanguage, key)) {
            // @ts-ignore
            if (LegalAgreementLanguage[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LegalAgreementLanguageFromJSON(json: any): LegalAgreementLanguage {
    return LegalAgreementLanguageFromJSONTyped(json, false);
}

export function LegalAgreementLanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalAgreementLanguage {
    return json as LegalAgreementLanguage;
}

export function LegalAgreementLanguageToJSON(value?: LegalAgreementLanguage | null): any {
    return value as any;
}

